module.exports = __webpack_public_path__ + "static/img/6543_phase_function_Paper_Points.440ae80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6543_phase_function_Paper_Points.png
// module id = +a2j
// module chunks = 0